import {
	PAGE_METADATA_BANNER,
	SYSTEM_CONTENT_METADATA,
	ATL_PAGE_METADATA,
} from '@confluence/web-item-location/entry-points/webFragmentLocations.ts';

export const measuredLocations: string[] = [
	PAGE_METADATA_BANNER,
	SYSTEM_CONTENT_METADATA,
	ATL_PAGE_METADATA,
];
export const MEASURE_KEY = 'com.atlassian.plugins.atlassian-connect-plugin';

export type MeasuredLocationLoadedType = {
	// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
	location: string;
	items: string[];
	isLoaded: boolean;
};
